import { Box, Divider, List, ListItem, ListItemText, Typography } from "@material-ui/core";

export const LegendBoxList = (props) => {
  const {children, style, width, ...other} = props;
  const _style = {
    padding:0,
    width,
    ...style
  }
  return (
    <List style={_style} {...other}>
      {children}
    </List>
  );
};

export const LegendBoxListItem = (props) => {
  const {children, style, height, ...other} = props;
  const _style = {
    padding: 0,
    height,
    ...style
  }
  return (
    <ListItem style={_style} {...other}>
      {children}
    </ListItem>
  );
};

export const LegendBoxListItemText = (props) => {
  const {children, style, ...other} = props;
  const _style = {
    paddingLeft: 7,
    margin: 0,
    ...style
  }
  return (
    <ListItemText style={_style} {...other}>
      {children}
    </ListItemText>
  )
};

export const LegendCssIcoListItem = props => {
  const {background, text} = props;
  // const classes = useStyles({background: background});
  const styleBefore = {
    display: "inline-block",
    width: 14,
    height: 14,
    border: "1px solid #333",
    verticalAlign: "top",
    background: "#FFF"
  }
  const styleAfter = {
    display: "inline-block",
    width: 14,
    height: 14,
    border: "1px solid #333",
    position: "absolute",
    background: background
  }
  return (
    <LegendBoxListItem>
      <span style={styleBefore}/>
      <LegendBoxListItemText>{text}</LegendBoxListItemText>
      <span style={styleAfter}/>
    </LegendBoxListItem>
  )
}
export const LegendCssCircleIcoListItem = props => {
  const {background, text} = props;
  // const classes = useStyles({background: background});
  const styleCircle = {
    height: 12,
    width: 12,
    borderRadius: "50%",
    border: "solid 1px #000",
    background: background
  }
  return (
    <LegendBoxListItem>
      <Box style={styleCircle}></Box>
      <LegendBoxListItemText>{text}</LegendBoxListItemText>
    </LegendBoxListItem>
  )
}
export const LegendCssSquareIconListItem = props => {
  const {background, text} = props;
  // const classes = useStyles({background: background});
  const styleSquare = {
    height: 17,
    width: 12,
    border: "solid 1px #000",
    background: background
  }
  const styleText = {
    position: "relative",
    top: 9,
    textAlign: "right",
    left: 3
  }
  return (
    <LegendBoxListItem height={17}>
      <Box style={styleSquare}/>
      <LegendBoxListItemText style={styleText}>{text}</LegendBoxListItemText>
    </LegendBoxListItem>
  )
}
export const LegendListDivider = props => {
  const styleDivider = {
    width: 19,
    backgroundColor: "#000"
  }
  return (
    <LegendBoxListItem>
      <Divider style={styleDivider}></Divider>
    </LegendBoxListItem>
  )
}

export const LegendBoxContentsName = (props) => {
  const {children, ...other} = props;
  return (
    <Typography style={{textAlign: "left", fontSize: "0.875rem"}} {...other}>
      {children}
    </Typography>
  );
};